import { bootTool } from '../../core/boot';
import { mountEmailHeaders } from './ui';

bootTool('[data-kb-tool="email-header-analyzer"]', mountEmailHeaders);
